//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DMU.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[[],"ValidateWorksets",{},0,0],[["version"],"ValidateWorksetsWithVersion",{},1,0],[["part"],"ValidateSnapshots",{},1,0],[["part","version"],"ValidateSnapshotsWithVersion",{},2,0],[[],"ValidateAllObjects",{},0,0],[["assetName","value"],"SetAssetValidationValue",{},2,0],[[],"CleanAssetValidationValues",{},0,0],[["part"],"ValidateSections",{},1,0],[["part"],"ValidateMeasures",{},1,0]],[]];
SPLM.DMU.DMUDebugSession = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DMU.DMUDebugSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;